import React from 'react';
import './header.css';

/**
 * Renders the shared heading and action area used at the top of module pages.
 *
 * `rightContent` accepts complete controls so callers can retain permission
 * checks, route navigation, modal launchers, icons, and loading states.
 */
export default function Header({ text, title, subtitle, rightContent, children, className = '' }) {
    const heading = title || text;

    return (
        <header className={`module-page-header header_div ${className}`.trim()}>
            <div className='module-page-header__content'>
                <h1 className='module-page-header__title admin_header'>{heading}</h1>
                {subtitle && <p className='module-page-header__subtitle'>{subtitle}</p>}
                {children}
            </div>
            {rightContent && (
                <div className='module-page-header__actions header_right'>
                    {rightContent}
                </div>
            )}
        </header>
    );
};
